import React, { useState } from "react";
import { toast } from "react-toastify";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";

// import JS files
import PanelFilter from "../../../shares/PanelFilter";
import PanelTemplate from "../../../shares/PanelTemplate";
import PanelTable from "../../../shares/PanelTable";
import MuiPagination from "../../../shares/MuiPagination";
import OrderDetails from "./OrderDetails";
import RemoveOrder from "./RemoveOrder";
import useFetch from "../../../../context/useFetch";
import { useUserData } from "../../../../context/UserDataContext";
import { fixNumbers } from "../../../../utils";
import { useNavigate } from "react-router-dom";
import PrintIcon from "@mui/icons-material/Print";
import MuiButton from "../../../shares/MuiButton";
import PrintOrderDetailNavigator from "../PrintOrderDetailNavigator";

const TabOne = (props) => {
  const [isFilterOn, setIsFilterOn] = useState(false);
  const [codeFilter, setCodeFilter] = useState(null);

  const filterList = [
    {
      type: "textField",
      label_fa: "سند",
      label_en: "code",
      state: codeFilter,
    },
  ];

  const headersList = [
    { colName: "unique_id", name: "سند " },
    { colName: "created_at", name: "تاریخ ثبت سفارش" },
    { colName: "total", name: "وزن" },
    // { colName: "factor_status", name: "وضعیت" },
    { colName: "status", name: "جزئیات سفارش" },
    { colName: "print", name: "چاپ سفارش" },

    { colName: "remove", name: "لغو سفارش" },
  ];
  const mobileHeadersList = [
    { colName: "unique_id", name: "سند " },
    { colName: "created_at", name: "تاریخ ثبت سفارش" },
    { colName: "total", name: "وزن" },
  ];

  const dataKey = ["unique_id", "created_at", "total"];

  const [onprogressOerdersList, setOnprogressOerdersList] = useState({
    results: [],
  });
  const navigate = useNavigate();

  const { userData } = useUserData();
  const [paginationPageInfo, setPaginationPageInfo] = useState({
    current: 1,
    pageSize: 30,
    count: 0,
  });
  const getOnprogressOrderApi = useFetch({
    method: "get",
    url: `User_Service/${userData.username}/customer_get_onprogress_order`,
    params: { unique_id: fixNumbers(codeFilter) },
    trigger: true,
    pagination: paginationPageInfo,
    setter: setOnprogressOerdersList,
    argFunc: (res) => {
      setPaginationPageInfo({
        current: res.current,
        pageSize: res.pageSize,
        count: res.count,
        next: res.next,
        previous: res.previous,
      });
    },
    errMessage: (mess) => {
      toast.error("خطایی رخ داده است", {
        position: toast.POSITION.TOP_CENTER,
      });
    },
  });

  const update_filter = (state, e) => {
    if (state == "code") setCodeFilter(e.length > 0 ? e : null);
  };

  const filter = () => {
    if (codeFilter !== null) {
      setIsFilterOn(true);
      getOnprogressOrderApi.reFetch();
    }
  };

  const reset_filter = () => {
    setCodeFilter(null);
    getOnprogressOrderApi.reFetch();
  };

  const buttonsList = [
    {
      label: "جزییات سفارش",
      component: (it) => (
        <OrderDetails
          selectedRow={it}
          getOnprogressOrderApi={getOnprogressOrderApi}
        />
      ),
    },
  ];

  const actionsList = [
    {
      label: "چاپ",
      component: (it) => (
        <PrintOrderDetailNavigator inCurrentOrder selectedRow={it} />
      ),
    },
    {
      label: "لغو سفارش",
      component: (it) => (
        <RemoveOrder
          selectedRow={it}
          getOnprogressOrderApi={getOnprogressOrderApi}
        />
      ),
    },
  ];
  const onChangePage = (e, page) => {
    setPaginationPageInfo({
      ...paginationPageInfo,
      current: page,
    });
    setOnprogressOerdersList({ results: [] });

    getOnprogressOrderApi.reFetch();
  };
  const handelPrintReport = () => {
    // navigate(`/print-current-orders/current/${codeFilter}/`);
    window.open(
      `/print-current-orders/current/${codeFilter}/`,
      "_blank"
      // "rel=noopener noreferrer"
    );
  };
  return (
    <>
      <PanelFilter
        header="فیلتر سفارش‌ها:"
        list={filterList}
        update_filter={update_filter}
        filter={filter}
        reset_filter={reset_filter}
      />
      <div className="flex justify-end">
        <MuiButton
          onClick={handelPrintReport}
          variant="outlined"
          icon={<PrintIcon />}
          color="primary"
          text="چاپ گزارش"
          margin="mr-2"
        />
      </div>
      <PanelTable
        header="لیست سفارش‌های جاری:"
        headers={headersList}
        mobileHeaders={mobileHeadersList}
        data={onprogressOerdersList.results}
        dataKey={dataKey}
        buttons={buttonsList}
        actions={actionsList}
        icon={<AccountBalanceIcon />}
      />
      <MuiPagination
        onChange={onChangePage}
        count={Math.ceil(
          paginationPageInfo.count / paginationPageInfo.pageSize
        )}
      />
    </>
  );
};

export default TabOne;
